<template>
  <div class="auto-continue-container">
    <div class="completion-message">
      <div class="completion-icon">✅</div>
      <div class="completion-text">
        <p class="completion-title">{{ $t('backgroundInfo.complete') }}</p>
        <p class="completion-subtitle">{{ $t('backgroundInfo.startingAssessment') }}</p>
      </div>
      <div class="spinner-border text-primary mt-2" role="status">
        <span class="visually-hidden">{{ $t('common.loading') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { useAssessment } from '@/composables/useAssessment';

export default {
  name: 'BackgroundCollectionComplete',
  props: {
    userId: String,
    dialogId: String,
    metadata: Object
  },
  setup(props, { emit }) {
    const { startAssessment } = useAssessment();

    const continueToAssessment = async () => {
      try {
        await startAssessment(
          props.metadata?.lang,
          props.metadata?.courseId
        );
        emit('newChatRequest');
      } catch (error) {
        console.error('Error starting assessment:', error);
        // Fallback: emit anyway so user isn't stuck
        emit('newChatRequest');
      }
    };

    // Automatically start assessment when component mounts
    onMounted(() => {
      // Small delay for UX - let user see the completion message briefly
      setTimeout(() => {
        continueToAssessment();
      }, 1500);
    });

    return {};
  }
};
</script>

<style scoped>
.auto-continue-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
}

.completion-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: var(--al-surface-sunken);
  border-radius: 1rem;
  padding: 2rem 1.5rem;
  box-shadow: var(--al-shadow-sm);
  max-width: 400px;
}

.completion-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  animation: bounce 1s ease-in-out;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .completion-icon {
    animation: none;
  }
}

.completion-text {
  margin-bottom: 1rem;
}

/* This is a transitional "starting assessment" screen, not an achievement.
   Ink text: --al-primary on --al-surface-muted is ~3.0:1 and fails AA at
   this size; the spinner already carries the blue-progress signal. */
.completion-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--al-text);
  margin-bottom: 0.5rem;
}

.completion-subtitle {
  font-size: 1rem;
  color: var(--al-text-muted);
  margin-bottom: 0;
}

.spinner-border {
  width: 2rem;
  height: 2rem;
}

/* Mobile responsiveness */
@media (max-width: 767px) {
  .auto-continue-container {
    padding: 1rem;
  }

  .completion-message {
    padding: 1.5rem 1rem;
  }

  .completion-icon {
    font-size: 2.5rem;
  }

  .completion-title {
    font-size: 1.1rem;
  }

  .completion-subtitle {
    font-size: 0.95rem;
  }
}
</style>